import Vue from "vue";
import Router from "vue-router";
//
import store from "@/store";
//
import Main from "@/components/pages/Main";
import Settings from "@/components/pages/Settings";
import Valutes from "@/components/pages/Valutes";
import CrossRate from "@/components/pages/CrossRate";
import CrossRateEdit from "@/components/pages/CrossRate/edit";
import Wallets from "@/components/pages/Wallets";
import Transactions from "@/components/pages/Transactions";
import TransactionsHistory from "@/components/pages/TransactionsHistory";
import TransactionsExport from "@/components/pages/TransactionsExport";
import Users from "@/components/pages/Users";
import ParseValutes from "@/components/pages/ParseValutes";
import Reserve from "@/components/pages/Reserve";
import Outputs from "@/components/pages/Outputs";
import Reviews from "@/components/pages/Reviews";
import NotFoundComponent from "@/components/pages/NotFound";
import TradePairs from "@/components/pages/TradePairs";
import WalletGeneration from "@/components/pages/WalletGeneration";
import Ledger from "@/components/pages/Ledger";
import LedgerAdd from "@/components/pages/Ledger/add";
import LedgerFull from "@/components/pages/Ledger/full";
import BalanceFull from "@/components/pages/Ledger/fullbalance";
import LedgerAddTransaction from "@/components/pages/Ledger/addTransaction";
import Deposits from "@/components/pages/Deposits";
import Sites from "@/components/pages/Sites";
import ApiUsers from "@/components/pages/ApiUsers";
import ApiUser from "@/components/pages/ApiUsers/Stats";
import Cards from "@/components/pages/Cards";
import SourceTypes from "@/components/pages/SourceTypes";
import Projects from "@/components/pages/Projects";
import ValuteCities from "@/components/pages/ValuteCities";
import Login from "@/components/pages/Login";
import ChangePassword from "@/components/pages/ChangePassword";
//
Vue.use(Router);
//
const router = new Router({
  mode: "history",
  base: process.env.NODE_ENV === "production" ? "/" : "/",
  routes: [
    { path: "/login", name: "Login", component: Login },
    { path: "/change-password", name: "ChangePassword", component: ChangePassword },
    { path: "/", name: "Main", component: Main },
    { path: "/settings", name: "Settings", component: Settings },
    { path: "/valutes", name: "Valutes", component: Valutes },
    { path: "/cross-rate", name: "CrossRate", component: CrossRate },
    {
      path: "/cross-rate/edit",
      name: "CrossRateNew",
      component: CrossRateEdit
    },
    {
      path: "/cross-rate/edit/:id",
      name: "CrossRateEdit",
      component: CrossRateEdit
    },
    { path: "/trade-pairs", name: "TradePairs", component: TradePairs },
    { path: "/parse-valutes", name: "ParseValutes", component: ParseValutes },
    { path: "/reserve", name: "Reserve", component: Reserve },
    { path: "/wallets", name: "Wallets", component: Wallets },
    { path: "/transactions", name: "Transactions", component: Transactions },
    { path: "/sites", name: "Sites", component: Sites },
    { path: "/sourcetypes", name: "SourceTypes", component: SourceTypes },
    { path: "/projects", name: "Projects", component: Projects },
    { path: "/valute-cities", name: "ValuteCities", component: ValuteCities },
    { path: "/apiusers", name: "ApiUsers", component: ApiUsers },
    { path: "/apiusers/:id", name: "ApiUser", component: ApiUser },
    { path: "/cards", name: "RTApiCards", component: Cards },
    {
      path: "/transactions-history",
      name: "TransactionsHistory",
      component: TransactionsHistory
    },
    {
      path: "/transactions-export/:filterdata",
      name: "TransactionsExport",
      component: TransactionsExport
    },
    { path: "/users", name: "Users", component: Users },
    { path: "/outputs", name: "Outputs", component: Outputs },
    { path: "/reviews", name: "Reviews", component: Reviews },
    {
      path: "/wallet-generation",
      name: "WalletGeneration",
      component: WalletGeneration
    },
    {
      path: "/deposits",
      name: "Deposits",
      component: Deposits
    },
    {
      path: "/ledger",
      name: "Ledger",
      component: Ledger
    },
    {
      path: "/ledger/add",
      name: "LedgerAdd",
      component: LedgerAdd
    },
    {
      path: "/ledger/add/:id",
      name: "LedgerEdit",
      component: LedgerAdd
    },
    {
      path: "/ledger/full/:id",
      name: "LedgerFull",
      component: LedgerFull
    },
    {
      path: "/ledger/fullbalance/:id",
      name: "BalanceFull",
      component: BalanceFull
    },
    {
      path: "/ledger/add-transaction/:transactionId",
      name: "LedgerAddByTransactionId",
      component: LedgerAddTransaction
    },
    {
      path: "/:catchAll(.*)",
      component: NotFoundComponent,
      name: "NotFound"
    }
  ]
});
//
router.beforeEach((to, from, next) => {
  store.commit("setPage", to.name);
  next();
});
//
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js